import React from "react";
import { Link } from "react-router-dom";

const styles = {
  gold:
    "group inline-flex items-center justify-center gap-2 border border-dh-gold/70 bg-transparent px-8 py-4 font-body text-[11px] uppercase tracking-[0.22em] text-dh-gold transition-[background-color,color,border-color] duration-500 hover:bg-dh-gold hover:text-dh-bg2",
  solid:
    "group inline-flex items-center justify-center gap-2 border border-dh-cream/80 bg-dh-cream px-8 py-4 font-body text-[11px] uppercase tracking-[0.22em] text-dh-bg2 transition-[background-color,color,border-color] duration-500 hover:bg-transparent hover:text-dh-cream",
  ghost:
    "group inline-flex items-center justify-center gap-2 border border-dh-cream/25 bg-transparent px-8 py-4 font-body text-[11px] uppercase tracking-[0.22em] text-dh-cream transition-[background-color,color,border-color] duration-500 hover:border-dh-cream/70",
};

export default function CtaButton({
  to,
  href,
  onClick,
  type,
  variant = "gold",
  children,
  className = "",
  testId,
  disabled,
}) {
  const cls = `${styles[variant]} ${disabled ? "opacity-50 pointer-events-none" : ""} ${className}`;
  if (to)
    return (
      <Link to={to} className={cls} data-testid={testId}>
        {children}
      </Link>
    );
  if (href)
    return (
      <a href={href} className={cls} data-testid={testId} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  return (
    <button type={type || "button"} onClick={onClick} className={cls} data-testid={testId} disabled={disabled}>
      {children}
    </button>
  );
}
